import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExclusiveService } from 'src/app/shared/services/exclusive.service';
import { ToastrService } from 'ngx-toastr';
import { emailValidator } from 'src/app/shared/services/app-validators';

@Component({
  selector: 'molla-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  subscribeForm: FormGroup;
  enable = false;

  constructor(
    private fb: FormBuilder,
    private exclusiveService: ExclusiveService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscribeForm = this.fb.group({
      email: ['', [Validators.required, emailValidator]]
    });
  }

  onSubmit(value: any): void {
    this.enable = true;
    if (!this.subscribeForm.valid) {
      return;
    }
    this.exclusiveService.addSubscribe(value.email).subscribe(
      (data: any) => {
        this.toastrService.success('Subscribed successfully!');
        this.subscribeForm.reset();
        this.enable = false;
      },
      (error: any) => {
        this.toastrService.error('Something went wrong. Please try again.');
      }
    );
  }
}
